import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import { ProfileClient } from '@atlaskit/profilecard/profile-card-client';

import type { FeatureFlagsType } from '@confluence/session-data/entry-points/SessionDataTypes.ts';

import { UserProfileClientForConfluence } from './UserProfileClientForConfluence.ts';

const DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';

const USER_PROFILE_CONFIG = {
	url: DIRECTORY_GRAPHQL_PATH,
	cacheSize: 100,
	cacheMaxAge: 5 * 60 * 1000, // - 5 minutes
};

export const getProfileClient: MemoizedFn<(cloudId: string, _: FeatureFlagsType) => ProfileClient> =
	memoize(
		(
			cloudId: string,
			/**
			 * @deprecated This is no longer used we should remove in a future
			 */
			_: FeatureFlagsType,
		): ProfileClient => {
			const profileClientConfig = {
				...USER_PROFILE_CONFIG,
				productIdentifier: 'confluence',
				cloudId,
			};

			return new ProfileClient(profileClientConfig, {
				userClient: new UserProfileClientForConfluence(profileClientConfig),
			});
		},
	);
